import { default as security30LgtM7ZgBMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/account/security.vue?macro=true";
import { default as credentialss7JUBm5jYnMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/account/settings/credentials.vue?macro=true";
import { default as danger_45zone9gWO3zITLyMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/account/settings/danger-zone.vue?macro=true";
import { default as indexxDtQg5NCSWMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/account/settings/index.vue?macro=true";
import { default as billinguceoDSDDrzMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/admin/billing.vue?macro=true";
import { default as branches2ixLcc5uwuMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/admin/branches.vue?macro=true";
import { default as bug_45reportsmuc0UyhFCvMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/admin/bug-reports.vue?macro=true";
import { default as importPrtuEGCWYOMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/admin/categories/import.vue?macro=true";
import { default as indexUnwDH0FsyuMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/admin/categories/index.vue?macro=true";
import { default as commissionscd5pMHnn3DMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/admin/commissions.vue?macro=true";
import { default as credit_45settlementi1QQ8svVIJMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/admin/customers/credit-settlement.vue?macro=true";
import { default as debtor_45managementgCxXdecQuLMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/admin/customers/debtor-management.vue?macro=true";
import { default as estimate4VeFi4TuXmMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/admin/customers/estimate.vue?macro=true";
import { default as indexjHBIQoC3PVMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/admin/customers/index.vue?macro=true";
import { default as loyaltysk9OyXvyqRMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/admin/customers/loyalty.vue?macro=true";
import { default as settlement_45by_45payment_45typedUZr2IrQ5YMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/admin/customers/settlement-by-payment-type.vue?macro=true";
import { default as dashboard5o3YXc1ugDMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/admin/dashboard.vue?macro=true";
import { default as discountslPTLCL8yTCMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/admin/discounts.vue?macro=true";
import { default as indexIdIWcczTKYMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/admin/index.vue?macro=true";
import { default as kitchen1QNULwF90PMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/admin/kitchen.vue?macro=true";
import { default as main_45officeEHciRPfOzXMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/admin/main-office.vue?macro=true";
import { default as _91id_932iEcJNbJY9Meta } from "/home/runner/work/pos-frontend/pos-frontend/pages/admin/modifiers/[id].vue?macro=true";
import { default as indexvOsAr4tycbMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/admin/modifiers/index.vue?macro=true";
import { default as newPc2synyRYdMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/admin/modifiers/new.vue?macro=true";
import { default as pos_45devicesdjKZQPt4gDMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/admin/pos-devices.vue?macro=true";
import { default as price_45optionsacvg4Yxty9Meta } from "/home/runner/work/pos-frontend/pos-frontend/pages/admin/price-options.vue?macro=true";
import { default as barcodema9sqVTqcoMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/admin/products/barcode.vue?macro=true";
import { default as editjM7gi2tJMvMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/admin/products/edit.vue?macro=true";
import { default as importagw4kRFlXyMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/admin/products/import.vue?macro=true";
import { default as indexHac9CMh0fQMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/admin/products/index.vue?macro=true";
import { default as newSqgPhmJe7MMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/admin/products/new.vue?macro=true";
import { default as queue0K57Cm8jvOMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/admin/queue.vue?macro=true";
import { default as chargesCqiPRofFNdMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/admin/reports/charges.vue?macro=true";
import { default as discountsnEVkcwBBTcMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/admin/reports/discounts.vue?macro=true";
import { default as expiration2t2D7YAFxCMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/admin/reports/expiration.vue?macro=true";
import { default as inventory_45value9jqPwCWvLGMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/admin/reports/inventory-value.vue?macro=true";
import { default as price_45optionsaExFvC2ogbMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/admin/reports/price-options.vue?macro=true";
import { default as receipts1Y49k9S8rMMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/admin/reports/receipts.vue?macro=true";
import { default as sales_45by_45categoryNmNJWrX2rSMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/admin/reports/sales-by-category.vue?macro=true";
import { default as sales_45by_45employeei9kgkZSs3uMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/admin/reports/sales-by-employee.vue?macro=true";
import { default as sales_45by_45item00HHuL4mmCMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/admin/reports/sales-by-item.vue?macro=true";
import { default as sales_45by_45modifier9uA90bAqq0Meta } from "/home/runner/work/pos-frontend/pos-frontend/pages/admin/reports/sales-by-modifier.vue?macro=true";
import { default as sales_45by_45payment_45typeIOr6qG4qbnMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/admin/reports/sales-by-payment-type.vue?macro=true";
import { default as sales_45summaryoT90hyxaOBMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/admin/reports/sales-summary.vue?macro=true";
import { default as shiftsa57IpfLCK4Meta } from "/home/runner/work/pos-frontend/pos-frontend/pages/admin/reports/shifts.vue?macro=true";
import { default as rolessLH9HwEYFzMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/admin/roles.vue?macro=true";
import { default as settingskXqBNp4cIpMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/admin/settings.vue?macro=true";
import { default as sub_45categories2Us4oaQA7zMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/admin/sub-categories.vue?macro=true";
import { default as usersSd8Fc4TnuoMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/admin/users.vue?macro=true";
import { default as whats_45newGOv2pNFjxJMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/admin/whats-new.vue?macro=true";
import { default as adminIYd14IruP0Meta } from "/home/runner/work/pos-frontend/pos-frontend/pages/admin.vue?macro=true";
import { default as customer_45displayp0C447y1hBMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/customer-display.vue?macro=true";
import { default as forgot_45password7rzEQ2qqJJMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/forgot-password.vue?macro=true";
import { default as indexwhgemikhqAMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/index.vue?macro=true";
import { default as loginNpwN33KmAHMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/login.vue?macro=true";
import { default as device_45idJ7fum6DYbNMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/pos/device-id.vue?macro=true";
import { default as registerBJJtOqsIrOMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/register.vue?macro=true";
import { default as reset_45passwordQX4yjRSgZbMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/reset-password.vue?macro=true";
import { default as signup7i7FiQgfUXMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/signup.vue?macro=true";
import { default as storefrontygDzWUcVopMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/storefront.vue?macro=true";
import { default as verify_45email1eGzIyAyWiMeta } from "/home/runner/work/pos-frontend/pos-frontend/pages/verify-email.vue?macro=true";
export default [
  {
    name: security30LgtM7ZgBMeta?.name ?? "account-security",
    path: security30LgtM7ZgBMeta?.path ?? "/account/security",
    meta: security30LgtM7ZgBMeta || {},
    alias: security30LgtM7ZgBMeta?.alias || [],
    redirect: security30LgtM7ZgBMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/account/security.vue").then(m => m.default || m)
  },
  {
    name: credentialss7JUBm5jYnMeta?.name ?? "account-settings-credentials",
    path: credentialss7JUBm5jYnMeta?.path ?? "/account/settings/credentials",
    meta: credentialss7JUBm5jYnMeta || {},
    alias: credentialss7JUBm5jYnMeta?.alias || [],
    redirect: credentialss7JUBm5jYnMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/account/settings/credentials.vue").then(m => m.default || m)
  },
  {
    name: danger_45zone9gWO3zITLyMeta?.name ?? "account-settings-danger-zone",
    path: danger_45zone9gWO3zITLyMeta?.path ?? "/account/settings/danger-zone",
    meta: danger_45zone9gWO3zITLyMeta || {},
    alias: danger_45zone9gWO3zITLyMeta?.alias || [],
    redirect: danger_45zone9gWO3zITLyMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/account/settings/danger-zone.vue").then(m => m.default || m)
  },
  {
    name: indexxDtQg5NCSWMeta?.name ?? "account-settings",
    path: indexxDtQg5NCSWMeta?.path ?? "/account/settings",
    meta: indexxDtQg5NCSWMeta || {},
    alias: indexxDtQg5NCSWMeta?.alias || [],
    redirect: indexxDtQg5NCSWMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/account/settings/index.vue").then(m => m.default || m)
  },
  {
    name: adminIYd14IruP0Meta?.name ?? undefined,
    path: adminIYd14IruP0Meta?.path ?? "/admin",
    meta: adminIYd14IruP0Meta || {},
    alias: adminIYd14IruP0Meta?.alias || [],
    redirect: adminIYd14IruP0Meta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/admin.vue").then(m => m.default || m),
    children: [
  {
    name: billinguceoDSDDrzMeta?.name ?? "admin-billing",
    path: billinguceoDSDDrzMeta?.path ?? "billing",
    meta: billinguceoDSDDrzMeta || {},
    alias: billinguceoDSDDrzMeta?.alias || [],
    redirect: billinguceoDSDDrzMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/admin/billing.vue").then(m => m.default || m)
  },
  {
    name: branches2ixLcc5uwuMeta?.name ?? "admin-branches",
    path: branches2ixLcc5uwuMeta?.path ?? "branches",
    meta: branches2ixLcc5uwuMeta || {},
    alias: branches2ixLcc5uwuMeta?.alias || [],
    redirect: branches2ixLcc5uwuMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/admin/branches.vue").then(m => m.default || m)
  },
  {
    name: bug_45reportsmuc0UyhFCvMeta?.name ?? "admin-bug-reports",
    path: bug_45reportsmuc0UyhFCvMeta?.path ?? "bug-reports",
    meta: bug_45reportsmuc0UyhFCvMeta || {},
    alias: bug_45reportsmuc0UyhFCvMeta?.alias || [],
    redirect: bug_45reportsmuc0UyhFCvMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/admin/bug-reports.vue").then(m => m.default || m)
  },
  {
    name: importPrtuEGCWYOMeta?.name ?? "admin-categories-import",
    path: importPrtuEGCWYOMeta?.path ?? "categories/import",
    meta: importPrtuEGCWYOMeta || {},
    alias: importPrtuEGCWYOMeta?.alias || [],
    redirect: importPrtuEGCWYOMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/admin/categories/import.vue").then(m => m.default || m)
  },
  {
    name: indexUnwDH0FsyuMeta?.name ?? "admin-categories",
    path: indexUnwDH0FsyuMeta?.path ?? "categories",
    meta: indexUnwDH0FsyuMeta || {},
    alias: indexUnwDH0FsyuMeta?.alias || [],
    redirect: indexUnwDH0FsyuMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/admin/categories/index.vue").then(m => m.default || m)
  },
  {
    name: commissionscd5pMHnn3DMeta?.name ?? "admin-commissions",
    path: commissionscd5pMHnn3DMeta?.path ?? "commissions",
    meta: commissionscd5pMHnn3DMeta || {},
    alias: commissionscd5pMHnn3DMeta?.alias || [],
    redirect: commissionscd5pMHnn3DMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/admin/commissions.vue").then(m => m.default || m)
  },
  {
    name: credit_45settlementi1QQ8svVIJMeta?.name ?? "admin-customers-credit-settlement",
    path: credit_45settlementi1QQ8svVIJMeta?.path ?? "customers/credit-settlement",
    meta: credit_45settlementi1QQ8svVIJMeta || {},
    alias: credit_45settlementi1QQ8svVIJMeta?.alias || [],
    redirect: credit_45settlementi1QQ8svVIJMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/admin/customers/credit-settlement.vue").then(m => m.default || m)
  },
  {
    name: debtor_45managementgCxXdecQuLMeta?.name ?? "admin-customers-debtor-management",
    path: debtor_45managementgCxXdecQuLMeta?.path ?? "customers/debtor-management",
    meta: debtor_45managementgCxXdecQuLMeta || {},
    alias: debtor_45managementgCxXdecQuLMeta?.alias || [],
    redirect: debtor_45managementgCxXdecQuLMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/admin/customers/debtor-management.vue").then(m => m.default || m)
  },
  {
    name: estimate4VeFi4TuXmMeta?.name ?? "admin-customers-estimate",
    path: estimate4VeFi4TuXmMeta?.path ?? "customers/estimate",
    meta: estimate4VeFi4TuXmMeta || {},
    alias: estimate4VeFi4TuXmMeta?.alias || [],
    redirect: estimate4VeFi4TuXmMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/admin/customers/estimate.vue").then(m => m.default || m)
  },
  {
    name: indexjHBIQoC3PVMeta?.name ?? "admin-customers",
    path: indexjHBIQoC3PVMeta?.path ?? "customers",
    meta: indexjHBIQoC3PVMeta || {},
    alias: indexjHBIQoC3PVMeta?.alias || [],
    redirect: indexjHBIQoC3PVMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/admin/customers/index.vue").then(m => m.default || m)
  },
  {
    name: loyaltysk9OyXvyqRMeta?.name ?? "admin-customers-loyalty",
    path: loyaltysk9OyXvyqRMeta?.path ?? "customers/loyalty",
    meta: loyaltysk9OyXvyqRMeta || {},
    alias: loyaltysk9OyXvyqRMeta?.alias || [],
    redirect: loyaltysk9OyXvyqRMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/admin/customers/loyalty.vue").then(m => m.default || m)
  },
  {
    name: settlement_45by_45payment_45typedUZr2IrQ5YMeta?.name ?? "admin-customers-settlement-by-payment-type",
    path: settlement_45by_45payment_45typedUZr2IrQ5YMeta?.path ?? "customers/settlement-by-payment-type",
    meta: settlement_45by_45payment_45typedUZr2IrQ5YMeta || {},
    alias: settlement_45by_45payment_45typedUZr2IrQ5YMeta?.alias || [],
    redirect: settlement_45by_45payment_45typedUZr2IrQ5YMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/admin/customers/settlement-by-payment-type.vue").then(m => m.default || m)
  },
  {
    name: dashboard5o3YXc1ugDMeta?.name ?? "admin-dashboard",
    path: dashboard5o3YXc1ugDMeta?.path ?? "dashboard",
    meta: dashboard5o3YXc1ugDMeta || {},
    alias: dashboard5o3YXc1ugDMeta?.alias || [],
    redirect: dashboard5o3YXc1ugDMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/admin/dashboard.vue").then(m => m.default || m)
  },
  {
    name: discountslPTLCL8yTCMeta?.name ?? "admin-discounts",
    path: discountslPTLCL8yTCMeta?.path ?? "discounts",
    meta: discountslPTLCL8yTCMeta || {},
    alias: discountslPTLCL8yTCMeta?.alias || [],
    redirect: discountslPTLCL8yTCMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/admin/discounts.vue").then(m => m.default || m)
  },
  {
    name: indexIdIWcczTKYMeta?.name ?? "admin",
    path: indexIdIWcczTKYMeta?.path ?? "",
    meta: indexIdIWcczTKYMeta || {},
    alias: indexIdIWcczTKYMeta?.alias || [],
    redirect: indexIdIWcczTKYMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/admin/index.vue").then(m => m.default || m)
  },
  {
    name: kitchen1QNULwF90PMeta?.name ?? "admin-kitchen",
    path: kitchen1QNULwF90PMeta?.path ?? "kitchen",
    meta: kitchen1QNULwF90PMeta || {},
    alias: kitchen1QNULwF90PMeta?.alias || [],
    redirect: kitchen1QNULwF90PMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/admin/kitchen.vue").then(m => m.default || m)
  },
  {
    name: main_45officeEHciRPfOzXMeta?.name ?? "admin-main-office",
    path: main_45officeEHciRPfOzXMeta?.path ?? "main-office",
    meta: main_45officeEHciRPfOzXMeta || {},
    alias: main_45officeEHciRPfOzXMeta?.alias || [],
    redirect: main_45officeEHciRPfOzXMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/admin/main-office.vue").then(m => m.default || m)
  },
  {
    name: _91id_932iEcJNbJY9Meta?.name ?? "admin-modifiers-id",
    path: _91id_932iEcJNbJY9Meta?.path ?? "modifiers/:id()",
    meta: _91id_932iEcJNbJY9Meta || {},
    alias: _91id_932iEcJNbJY9Meta?.alias || [],
    redirect: _91id_932iEcJNbJY9Meta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/admin/modifiers/[id].vue").then(m => m.default || m)
  },
  {
    name: indexvOsAr4tycbMeta?.name ?? "admin-modifiers",
    path: indexvOsAr4tycbMeta?.path ?? "modifiers",
    meta: indexvOsAr4tycbMeta || {},
    alias: indexvOsAr4tycbMeta?.alias || [],
    redirect: indexvOsAr4tycbMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/admin/modifiers/index.vue").then(m => m.default || m)
  },
  {
    name: newPc2synyRYdMeta?.name ?? "admin-modifiers-new",
    path: newPc2synyRYdMeta?.path ?? "modifiers/new",
    meta: newPc2synyRYdMeta || {},
    alias: newPc2synyRYdMeta?.alias || [],
    redirect: newPc2synyRYdMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/admin/modifiers/new.vue").then(m => m.default || m)
  },
  {
    name: pos_45devicesdjKZQPt4gDMeta?.name ?? "admin-pos-devices",
    path: pos_45devicesdjKZQPt4gDMeta?.path ?? "pos-devices",
    meta: pos_45devicesdjKZQPt4gDMeta || {},
    alias: pos_45devicesdjKZQPt4gDMeta?.alias || [],
    redirect: pos_45devicesdjKZQPt4gDMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/admin/pos-devices.vue").then(m => m.default || m)
  },
  {
    name: price_45optionsacvg4Yxty9Meta?.name ?? "admin-price-options",
    path: price_45optionsacvg4Yxty9Meta?.path ?? "price-options",
    meta: price_45optionsacvg4Yxty9Meta || {},
    alias: price_45optionsacvg4Yxty9Meta?.alias || [],
    redirect: price_45optionsacvg4Yxty9Meta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/admin/price-options.vue").then(m => m.default || m)
  },
  {
    name: barcodema9sqVTqcoMeta?.name ?? "admin-products-barcode",
    path: barcodema9sqVTqcoMeta?.path ?? "products/barcode",
    meta: barcodema9sqVTqcoMeta || {},
    alias: barcodema9sqVTqcoMeta?.alias || [],
    redirect: barcodema9sqVTqcoMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/admin/products/barcode.vue").then(m => m.default || m)
  },
  {
    name: editjM7gi2tJMvMeta?.name ?? "admin-products-edit",
    path: editjM7gi2tJMvMeta?.path ?? "products/edit",
    meta: editjM7gi2tJMvMeta || {},
    alias: editjM7gi2tJMvMeta?.alias || [],
    redirect: editjM7gi2tJMvMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/admin/products/edit.vue").then(m => m.default || m)
  },
  {
    name: importagw4kRFlXyMeta?.name ?? "admin-products-import",
    path: importagw4kRFlXyMeta?.path ?? "products/import",
    meta: importagw4kRFlXyMeta || {},
    alias: importagw4kRFlXyMeta?.alias || [],
    redirect: importagw4kRFlXyMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/admin/products/import.vue").then(m => m.default || m)
  },
  {
    name: indexHac9CMh0fQMeta?.name ?? "admin-products",
    path: indexHac9CMh0fQMeta?.path ?? "products",
    meta: indexHac9CMh0fQMeta || {},
    alias: indexHac9CMh0fQMeta?.alias || [],
    redirect: indexHac9CMh0fQMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/admin/products/index.vue").then(m => m.default || m)
  },
  {
    name: newSqgPhmJe7MMeta?.name ?? "admin-products-new",
    path: newSqgPhmJe7MMeta?.path ?? "products/new",
    meta: newSqgPhmJe7MMeta || {},
    alias: newSqgPhmJe7MMeta?.alias || [],
    redirect: newSqgPhmJe7MMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/admin/products/new.vue").then(m => m.default || m)
  },
  {
    name: queue0K57Cm8jvOMeta?.name ?? "admin-queue",
    path: queue0K57Cm8jvOMeta?.path ?? "queue",
    meta: queue0K57Cm8jvOMeta || {},
    alias: queue0K57Cm8jvOMeta?.alias || [],
    redirect: queue0K57Cm8jvOMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/admin/queue.vue").then(m => m.default || m)
  },
  {
    name: chargesCqiPRofFNdMeta?.name ?? "admin-reports-charges",
    path: chargesCqiPRofFNdMeta?.path ?? "reports/charges",
    meta: chargesCqiPRofFNdMeta || {},
    alias: chargesCqiPRofFNdMeta?.alias || [],
    redirect: chargesCqiPRofFNdMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/admin/reports/charges.vue").then(m => m.default || m)
  },
  {
    name: discountsnEVkcwBBTcMeta?.name ?? "admin-reports-discounts",
    path: discountsnEVkcwBBTcMeta?.path ?? "reports/discounts",
    meta: discountsnEVkcwBBTcMeta || {},
    alias: discountsnEVkcwBBTcMeta?.alias || [],
    redirect: discountsnEVkcwBBTcMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/admin/reports/discounts.vue").then(m => m.default || m)
  },
  {
    name: expiration2t2D7YAFxCMeta?.name ?? "admin-reports-expiration",
    path: expiration2t2D7YAFxCMeta?.path ?? "reports/expiration",
    meta: expiration2t2D7YAFxCMeta || {},
    alias: expiration2t2D7YAFxCMeta?.alias || [],
    redirect: expiration2t2D7YAFxCMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/admin/reports/expiration.vue").then(m => m.default || m)
  },
  {
    name: inventory_45value9jqPwCWvLGMeta?.name ?? "admin-reports-inventory-value",
    path: inventory_45value9jqPwCWvLGMeta?.path ?? "reports/inventory-value",
    meta: inventory_45value9jqPwCWvLGMeta || {},
    alias: inventory_45value9jqPwCWvLGMeta?.alias || [],
    redirect: inventory_45value9jqPwCWvLGMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/admin/reports/inventory-value.vue").then(m => m.default || m)
  },
  {
    name: price_45optionsaExFvC2ogbMeta?.name ?? "admin-reports-price-options",
    path: price_45optionsaExFvC2ogbMeta?.path ?? "reports/price-options",
    meta: price_45optionsaExFvC2ogbMeta || {},
    alias: price_45optionsaExFvC2ogbMeta?.alias || [],
    redirect: price_45optionsaExFvC2ogbMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/admin/reports/price-options.vue").then(m => m.default || m)
  },
  {
    name: receipts1Y49k9S8rMMeta?.name ?? "admin-reports-receipts",
    path: receipts1Y49k9S8rMMeta?.path ?? "reports/receipts",
    meta: receipts1Y49k9S8rMMeta || {},
    alias: receipts1Y49k9S8rMMeta?.alias || [],
    redirect: receipts1Y49k9S8rMMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/admin/reports/receipts.vue").then(m => m.default || m)
  },
  {
    name: sales_45by_45categoryNmNJWrX2rSMeta?.name ?? "admin-reports-sales-by-category",
    path: sales_45by_45categoryNmNJWrX2rSMeta?.path ?? "reports/sales-by-category",
    meta: sales_45by_45categoryNmNJWrX2rSMeta || {},
    alias: sales_45by_45categoryNmNJWrX2rSMeta?.alias || [],
    redirect: sales_45by_45categoryNmNJWrX2rSMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/admin/reports/sales-by-category.vue").then(m => m.default || m)
  },
  {
    name: sales_45by_45employeei9kgkZSs3uMeta?.name ?? "admin-reports-sales-by-employee",
    path: sales_45by_45employeei9kgkZSs3uMeta?.path ?? "reports/sales-by-employee",
    meta: sales_45by_45employeei9kgkZSs3uMeta || {},
    alias: sales_45by_45employeei9kgkZSs3uMeta?.alias || [],
    redirect: sales_45by_45employeei9kgkZSs3uMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/admin/reports/sales-by-employee.vue").then(m => m.default || m)
  },
  {
    name: sales_45by_45item00HHuL4mmCMeta?.name ?? "admin-reports-sales-by-item",
    path: sales_45by_45item00HHuL4mmCMeta?.path ?? "reports/sales-by-item",
    meta: sales_45by_45item00HHuL4mmCMeta || {},
    alias: sales_45by_45item00HHuL4mmCMeta?.alias || [],
    redirect: sales_45by_45item00HHuL4mmCMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/admin/reports/sales-by-item.vue").then(m => m.default || m)
  },
  {
    name: sales_45by_45modifier9uA90bAqq0Meta?.name ?? "admin-reports-sales-by-modifier",
    path: sales_45by_45modifier9uA90bAqq0Meta?.path ?? "reports/sales-by-modifier",
    meta: sales_45by_45modifier9uA90bAqq0Meta || {},
    alias: sales_45by_45modifier9uA90bAqq0Meta?.alias || [],
    redirect: sales_45by_45modifier9uA90bAqq0Meta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/admin/reports/sales-by-modifier.vue").then(m => m.default || m)
  },
  {
    name: sales_45by_45payment_45typeIOr6qG4qbnMeta?.name ?? "admin-reports-sales-by-payment-type",
    path: sales_45by_45payment_45typeIOr6qG4qbnMeta?.path ?? "reports/sales-by-payment-type",
    meta: sales_45by_45payment_45typeIOr6qG4qbnMeta || {},
    alias: sales_45by_45payment_45typeIOr6qG4qbnMeta?.alias || [],
    redirect: sales_45by_45payment_45typeIOr6qG4qbnMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/admin/reports/sales-by-payment-type.vue").then(m => m.default || m)
  },
  {
    name: sales_45summaryoT90hyxaOBMeta?.name ?? "admin-reports-sales-summary",
    path: sales_45summaryoT90hyxaOBMeta?.path ?? "reports/sales-summary",
    meta: sales_45summaryoT90hyxaOBMeta || {},
    alias: sales_45summaryoT90hyxaOBMeta?.alias || [],
    redirect: sales_45summaryoT90hyxaOBMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/admin/reports/sales-summary.vue").then(m => m.default || m)
  },
  {
    name: shiftsa57IpfLCK4Meta?.name ?? "admin-reports-shifts",
    path: shiftsa57IpfLCK4Meta?.path ?? "reports/shifts",
    meta: shiftsa57IpfLCK4Meta || {},
    alias: shiftsa57IpfLCK4Meta?.alias || [],
    redirect: shiftsa57IpfLCK4Meta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/admin/reports/shifts.vue").then(m => m.default || m)
  },
  {
    name: rolessLH9HwEYFzMeta?.name ?? "admin-roles",
    path: rolessLH9HwEYFzMeta?.path ?? "roles",
    meta: rolessLH9HwEYFzMeta || {},
    alias: rolessLH9HwEYFzMeta?.alias || [],
    redirect: rolessLH9HwEYFzMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/admin/roles.vue").then(m => m.default || m)
  },
  {
    name: settingskXqBNp4cIpMeta?.name ?? "admin-settings",
    path: settingskXqBNp4cIpMeta?.path ?? "settings",
    meta: settingskXqBNp4cIpMeta || {},
    alias: settingskXqBNp4cIpMeta?.alias || [],
    redirect: settingskXqBNp4cIpMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/admin/settings.vue").then(m => m.default || m)
  },
  {
    name: sub_45categories2Us4oaQA7zMeta?.name ?? "admin-sub-categories",
    path: sub_45categories2Us4oaQA7zMeta?.path ?? "sub-categories",
    meta: sub_45categories2Us4oaQA7zMeta || {},
    alias: sub_45categories2Us4oaQA7zMeta?.alias || [],
    redirect: sub_45categories2Us4oaQA7zMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/admin/sub-categories.vue").then(m => m.default || m)
  },
  {
    name: usersSd8Fc4TnuoMeta?.name ?? "admin-users",
    path: usersSd8Fc4TnuoMeta?.path ?? "users",
    meta: usersSd8Fc4TnuoMeta || {},
    alias: usersSd8Fc4TnuoMeta?.alias || [],
    redirect: usersSd8Fc4TnuoMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/admin/users.vue").then(m => m.default || m)
  },
  {
    name: whats_45newGOv2pNFjxJMeta?.name ?? "admin-whats-new",
    path: whats_45newGOv2pNFjxJMeta?.path ?? "whats-new",
    meta: whats_45newGOv2pNFjxJMeta || {},
    alias: whats_45newGOv2pNFjxJMeta?.alias || [],
    redirect: whats_45newGOv2pNFjxJMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/admin/whats-new.vue").then(m => m.default || m)
  }
]
  },
  {
    name: customer_45displayp0C447y1hBMeta?.name ?? "customer-display",
    path: customer_45displayp0C447y1hBMeta?.path ?? "/customer-display",
    meta: customer_45displayp0C447y1hBMeta || {},
    alias: customer_45displayp0C447y1hBMeta?.alias || [],
    redirect: customer_45displayp0C447y1hBMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/customer-display.vue").then(m => m.default || m)
  },
  {
    name: forgot_45password7rzEQ2qqJJMeta?.name ?? "forgot-password",
    path: forgot_45password7rzEQ2qqJJMeta?.path ?? "/forgot-password",
    meta: forgot_45password7rzEQ2qqJJMeta || {},
    alias: forgot_45password7rzEQ2qqJJMeta?.alias || [],
    redirect: forgot_45password7rzEQ2qqJJMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/forgot-password.vue").then(m => m.default || m)
  },
  {
    name: indexwhgemikhqAMeta?.name ?? "index",
    path: indexwhgemikhqAMeta?.path ?? "/",
    meta: indexwhgemikhqAMeta || {},
    alias: indexwhgemikhqAMeta?.alias || [],
    redirect: indexwhgemikhqAMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/index.vue").then(m => m.default || m)
  },
  {
    name: loginNpwN33KmAHMeta?.name ?? "login",
    path: loginNpwN33KmAHMeta?.path ?? "/login",
    meta: loginNpwN33KmAHMeta || {},
    alias: loginNpwN33KmAHMeta?.alias || [],
    redirect: loginNpwN33KmAHMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/login.vue").then(m => m.default || m)
  },
  {
    name: device_45idJ7fum6DYbNMeta?.name ?? "pos-device-id",
    path: device_45idJ7fum6DYbNMeta?.path ?? "/pos/device-id",
    meta: device_45idJ7fum6DYbNMeta || {},
    alias: device_45idJ7fum6DYbNMeta?.alias || [],
    redirect: device_45idJ7fum6DYbNMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/pos/device-id.vue").then(m => m.default || m)
  },
  {
    name: registerBJJtOqsIrOMeta?.name ?? "register",
    path: registerBJJtOqsIrOMeta?.path ?? "/register",
    meta: registerBJJtOqsIrOMeta || {},
    alias: registerBJJtOqsIrOMeta?.alias || [],
    redirect: registerBJJtOqsIrOMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/register.vue").then(m => m.default || m)
  },
  {
    name: reset_45passwordQX4yjRSgZbMeta?.name ?? "reset-password",
    path: reset_45passwordQX4yjRSgZbMeta?.path ?? "/reset-password",
    meta: reset_45passwordQX4yjRSgZbMeta || {},
    alias: reset_45passwordQX4yjRSgZbMeta?.alias || [],
    redirect: reset_45passwordQX4yjRSgZbMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/reset-password.vue").then(m => m.default || m)
  },
  {
    name: signup7i7FiQgfUXMeta?.name ?? "signup",
    path: signup7i7FiQgfUXMeta?.path ?? "/signup",
    meta: signup7i7FiQgfUXMeta || {},
    alias: signup7i7FiQgfUXMeta?.alias || [],
    redirect: signup7i7FiQgfUXMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/signup.vue").then(m => m.default || m)
  },
  {
    name: storefrontygDzWUcVopMeta?.name ?? "storefront",
    path: storefrontygDzWUcVopMeta?.path ?? "/storefront",
    meta: storefrontygDzWUcVopMeta || {},
    alias: storefrontygDzWUcVopMeta?.alias || [],
    redirect: storefrontygDzWUcVopMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/storefront.vue").then(m => m.default || m)
  },
  {
    name: verify_45email1eGzIyAyWiMeta?.name ?? "verify-email",
    path: verify_45email1eGzIyAyWiMeta?.path ?? "/verify-email",
    meta: verify_45email1eGzIyAyWiMeta || {},
    alias: verify_45email1eGzIyAyWiMeta?.alias || [],
    redirect: verify_45email1eGzIyAyWiMeta?.redirect,
    component: () => import("/home/runner/work/pos-frontend/pos-frontend/pages/verify-email.vue").then(m => m.default || m)
  }
]